

/**
 * Configure Axios to automatically inject X-Pinpoint-Program header
 * based on the request URL.
 * 
 * Rules:
 * - Skip absolute/external URLs
 * - /api/sat/* -> X-Pinpoint-Program: sat
 * - /api/isee/* -> X-Pinpoint-Program: isee
 * - /api/common/* -> No header
 */
import { Programs } from '../constants';

/**
 * Configure Axios to automatically inject X-Pinpoint-Program header
 * based on the request URL.
 * 
 * Rules:
 * - Skip absolute/external URLs
 * - /api/sat/* -> X-Pinpoint-Program: sat
 * - /api/isee/* -> X-Pinpoint-Program: isee
 * - /api/common/* -> No header
 */
export const setupAxiosProgramInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.request.use((config) => {
        if (!config?.url) return config;

        const url = config.url;

        // Absolute URL safety (skip external)
        if (url.startsWith("http://") || url.startsWith("https://")) return config;

        // Resolve full path (handling relative URLs)
        const base = config.baseURL ?? window.location.origin;
        // Handle case where url is relative but base is absolute
        const fullUrl = new URL(url, base.startsWith('http') ? base : window.location.origin);
        const pathname = fullUrl.pathname;

        if (pathname.startsWith("/api/sat/")) {
            config.headers = config.headers ?? {};
            config.headers["X-Pinpoint-Program"] = Programs.SAT;
        } else if (pathname.startsWith("/api/isee/")) {
            config.headers = config.headers ?? {};
            config.headers["X-Pinpoint-Program"] = Programs.ISEE;
        }
        // /api/common/ -> skip injection

        return config;
    });
};
